"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Certification = exports.CaretUp = exports.CaretDown = exports.Box = exports.ArrowRoundedVDP = exports.ArrowRoundedLeft = exports.ArrowRounded = exports.ArrowHover = exports.Arrow = void 0;
exports.Check = Check;
exports.CopyIcon = exports.ConfirmedIcon = exports.CollegeIcon = exports.CloseRounded = exports.CloseHeavy = exports.Close = exports.CircleSlashIcon = void 0;
Object.defineProperty(exports, "CustomIcon", {
  enumerable: true,
  get: function () {
    return _CustomIcon.default;
  }
});
exports.ZipSearch = exports.YoutubeIcon = exports.WhatsAppIcon = exports.WarrantyShield = exports.UnavailableIcon = exports.TwitterIcon = exports.TravelBags = exports.ToyotaPinZip = exports.ToyotaPhoneIcon = exports.ToyotaLogoIcon = exports.ToyotaInfoIcon = exports.ToyotaCaretUp = exports.ToyotaCaretRight = exports.ToyotaCaretDown = exports.TopUp = exports.TopDown = exports.TikTokIcon = exports.ThinArrow = exports.Swish = exports.Sun = exports.StandardIcon = exports.Share = exports.SaveAsPDF = exports.ProgramCompare = exports.PrinToPDF = exports.PointInspection = exports.Plus = exports.PlayButton = exports.PinterestIcon = exports.PinStar = exports.PinAlternate = exports.Pin = exports.PackageIcon = exports.OptionalIcon = exports.NoticeIcon = exports.Moon = exports.Minus = exports.MilitaryIcon = exports.Mileage = exports.MaintenanceWrench = exports.LocateStroke = exports.LoanerCar = exports.LexusPin = exports.LexusPhoneIcon = exports.LexusLogo = exports.Kebab = exports.InstagramIcon = exports.InfoIconThick = exports.InfoIconSlim = exports.InfoIcon = exports.HeartIcon = exports.GasCan = exports.GalleryArrowLexus = exports.FuelPumpAlternateElectric = exports.FuelPumpAlternate = exports.FuelPump = exports.FinancialIcon = exports.FilterSelector = exports.FacebookIcon = exports.Expand = exports.ErrorIcon = exports.EngineElectric = exports.Engine = exports.DownloadIcon = exports.DisclaimerInfoIcon = exports.Details = void 0;
var _CustomIcon = _interopRequireDefault(require("./CustomIcon"));
var _index = _interopRequireDefault(require("./index.styled"));
var _jsxRuntime = require("react/jsx-runtime");
const DisclaimerInfoIcon = function (_ref) {
  let {
    title = "Disclaimer Info Icon",
    ...props
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    ...props,
    fill: "none",
    "data-testid": "DisclaimerInfoIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: "8",
      cy: "8",
      r: "7",
      stroke: "#000",
      "stroke-width": "2"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      stroke: "#000",
      "stroke-width": "2",
      d: "M8 7v5"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: "8",
      cy: "5",
      r: "1",
      fill: "#000"
    })]
  });
};
exports.DisclaimerInfoIcon = DisclaimerInfoIcon;
const PrinToPDF = function (_ref2) {
  let {
    title = "Prin to PDF Icon",
    ...props
  } = _ref2;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "16",
    height: "16",
    style: {
      cursor: "pointer"
    },
    title: title,
    ...props,
    "data-testid": "PrinToPDF",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "lucide lucide-printer",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        x: "6",
        y: "14",
        width: "12",
        height: "8",
        rx: "1"
      })]
    })
  });
};
exports.PrinToPDF = PrinToPDF;
const Kebab = function (_ref3) {
  let {
    title = "Kebab Icon",
    ...props
  } = _ref3;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "11 11 22 22",
    ...props,
    "data-testid": "Kebab",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: "22",
      cy: "14",
      r: "2"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: "22",
      cy: "22",
      r: "2"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: "22",
      cy: "30",
      r: "2"
    })]
  });
};
exports.Kebab = Kebab;
const Share = function (_ref4) {
  let {
    title = "Share Icon",
    ...props
  } = _ref4;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "12 11 21 22",
    ...props,
    "data-testid": "Share",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M28 18.5C29.933 18.5 31.5 16.933 31.5 15C31.5 13.067 29.933 11.5 28 11.5C26.067 11.5 24.5 13.067 24.5 15C24.5 15.3919 24.5644 15.7688 24.6833 16.1207L18.5857 19.6411C17.9457 18.9399 17.0242 18.5 16 18.5C14.067 18.5 12.5 20.067 12.5 22C12.5 23.933 14.067 25.5 16 25.5C17.0799 25.5 18.0456 25.0109 18.6876 24.2422L24.7359 27.7341C24.5836 28.1267 24.5 28.5536 24.5 29C24.5 30.933 26.067 32.5 28 32.5C29.933 32.5 31.5 30.933 31.5 29C31.5 27.067 29.933 25.5 28 25.5C26.8715 25.5 25.8677 26.0341 25.2277 26.8633L19.2128 23.3907C19.3976 22.9644 19.5 22.4942 19.5 22C19.5 21.4516 19.3739 20.9326 19.149 20.4706L25.1368 17.0135C25.7703 17.9126 26.8165 18.5 28 18.5ZM28 17.5C29.3807 17.5 30.5 16.3807 30.5 15C30.5 13.6193 29.3807 12.5 28 12.5C26.6193 12.5 25.5 13.6193 25.5 15C25.5 16.3807 26.6193 17.5 28 17.5ZM30.5 29C30.5 30.3807 29.3807 31.5 28 31.5C26.6193 31.5 25.5 30.3807 25.5 29C25.5 27.6193 26.6193 26.5 28 26.5C29.3807 26.5 30.5 27.6193 30.5 29ZM16 24.5C17.3807 24.5 18.5 23.3807 18.5 22C18.5 20.6193 17.3807 19.5 16 19.5C14.6193 19.5 13.5 20.6193 13.5 22C13.5 23.3807 14.6193 24.5 16 24.5Z"
    })]
  });
};
exports.Share = Share;
const Arrow = function (_ref5) {
  let {
    title = "Arrow Icon",
    ...props
  } = _ref5;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.39 7.45",
    ...props,
    "data-testid": "Arrow",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
      points: "13.39 0.76 12.63 0 6.7 5.94 0.76 0 0 0.76 6.7 7.45 6.7 7.45 6.7 7.45 13.39 0.76"
    })]
  });
};
exports.Arrow = Arrow;
const GalleryArrowLexus = function (_ref6) {
  let {
    fill = "none",
    title = "Arrow Icon",
    ...props
  } = _ref6;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "28",
    viewBox: "0 0 16 28",
    fill: fill,
    ...props,
    "data-testid": "GalleryArrowLexus",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M1.5 26.5149L14.5 13.9023",
      "stroke-linecap": "square"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M1.5 1.28972L14.5 13.9023",
      "stroke-linecap": "square"
    })]
  });
};
exports.GalleryArrowLexus = GalleryArrowLexus;
const ArrowHover = function (_ref7) {
  let {
    title = "Arrow Icon hover",
    ...props
  } = _ref7;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    width: "17",
    height: "15",
    viewBox: "0 0 17 15",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    "data-testid": "ArrowHover",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.0038 7.5C16.0038 8.05228 15.556 8.5 15.0038 8.5L3.41275 8.5L7.36247 12.4497C7.753 12.8402 7.753 13.4734 7.36247 13.8639C6.97195 14.2545 6.33878 14.2545 5.94826 13.8639L0.291405 8.20708C-0.0991193 7.81656 -0.0991193 7.1834 0.291405 6.79287C0.29437 6.78991 0.297348 6.78696 0.30034 6.78405L5.94835 1.13603C6.33888 0.745509 6.97204 0.745508 7.36257 1.13603C7.75309 1.52656 7.75309 2.15972 7.36257 2.55025L3.41281 6.5L15.0038 6.5C15.556 6.5 16.0038 6.94772 16.0038 7.5Z"
    })]
  });
};
exports.ArrowHover = ArrowHover;
const ArrowRounded = function (_ref8) {
  let {
    title = "Arrow Icon",
    ...props
  } = _ref8;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    ...props,
    "data-testid": "ArrowRounded",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.253 1.636A1 1 0 1 0 5.839 3.05L10.789 8l-4.95 4.95a1 1 0 0 0 1.414 1.414l5.657-5.657a1 1 0 0 0 0-1.414L7.253 1.636z"
    })]
  });
};
exports.ArrowRounded = ArrowRounded;
const ArrowRoundedLeft = function (_ref9) {
  let {
    title = "Arrow Icon",
    ...props
  } = _ref9;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    ...props,
    "data-testid": "ArrowRoundedLeft",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.253 1.636A1 1 0 0 1 8.667 3.05L3.717 8l4.95 4.95a1 1 0 1 1-1.414 1.414l-5.657-5.657a1 1 0 0 1 0-1.414L7.253 1.636z"
    })]
  });
};
exports.ArrowRoundedLeft = ArrowRoundedLeft;
const ArrowRoundedVDP = function (_ref10) {
  let {
    title = "Arrow Icon",
    ...props
  } = _ref10;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "12",
    viewBox: "0 0 13 12",
    ...props,
    "data-testid": "ArrowRoundedVDP",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.56825 0.905047C6.17772 0.514523 5.54456 0.514522 5.15403 0.905047C4.76351 1.29557 4.76351 1.92874 5.15403 2.31926L8.68912 5.85434L5.15321 9.39025C4.76269 9.78077 4.76269 10.4139 5.15321 10.8045C5.54373 11.195 6.1769 11.195 6.56742 10.8045L10.7849 6.58702C10.7937 6.57884 10.8023 6.57046 10.8109 6.5619C11.2014 6.17138 11.2014 5.53821 10.8109 5.14769L6.56825 0.905047Z"
    })]
  });
};
exports.ArrowRoundedVDP = ArrowRoundedVDP;
const ThinArrow = function (_ref11) {
  let {
    title = "Thin Arrow Icon",
    ...props
  } = _ref11;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.69 24.26",
    ...props,
    "data-testid": "ThinArrow",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
      points: "0.59 24.25 0.06 23.72 11.63 12.15 0 0.53 0.53 0 12.69 12.15 0.59 24.25"
    })]
  });
};
exports.ThinArrow = ThinArrow;
const Swish = function (_ref12) {
  let {
    title = "Swish Icon",
    ...props
  } = _ref12;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164.97 125.21",
    ...props,
    "data-testid": "Swish",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M178,138c-45.49-.63-87.69-9-118.84-23.48S11.64,81,13.09,61.14c.85-11.65,7.77-22.81,20-32.79l-19.53-6.8,25.61-4.4,25.61-4.4L60.71,24.64l-4.09,11.9L43.8,32.07c-29.52,25.1-23.57,53.69,23.07,75.42C96,121.06,138.42,129.2,177.93,130Z",
      transform: "translate(-13 -12.75)"
    })]
  });
};
exports.Swish = Swish;
const Expand = function (_ref13) {
  let {
    title = "Expand Icon",
    ...props
  } = _ref13;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.24 26.06",
    ...props,
    "data-testid": "Expand",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
      points: "8.67 16.78 1 24.45 1 20.99 0 20.99 0 26.06 0.06 26.06 0.06 26.06 5.13 26.06 5.13 25.06 1.8 25.06 9.38 17.49 8.67 16.78"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
      points: "26.19 0 26.19 0 21.12 0 21.12 1 24.44 1 16.86 8.57 17.57 9.28 25.24 1.61 25.24 5.07 26.24 5.07 26.24 0 26.19 0"
    })]
  });
};
exports.Expand = Expand;
const Sun = function (_ref14) {
  let {
    title = "Sun Icon",
    ...props
  } = _ref14;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 494.77 494.77",
    ...props,
    "data-testid": "Sun",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M331.56,154a129.54,129.54,0,1,0,70.49,69.73A128.74,128.74,0,0,0,331.56,154Zm53.67,161.8a110.81,110.81,0,1,1-.46-84.81A110.11,110.11,0,0,1,385.23,315.8Z",
      transform: "translate(-35.24 -28.87)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M200,105.14a9.37,9.37,0,1,0,17.15-7.55L190.32,36.76a9.37,9.37,0,1,0-17.15,7.55Z",
      transform: "translate(-35.24 -28.87)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M41.22,189.65l62,24.07a9.18,9.18,0,0,0,3.39.64,9.37,9.37,0,0,0,3.4-18.11L48,172.18a9.37,9.37,0,1,0-6.79,17.47Z",
      transform: "translate(-35.24 -28.87)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M104,341.78,43.14,368.56a9.37,9.37,0,1,0,7.55,17.15l60.82-26.78A9.37,9.37,0,1,0,104,341.78Z",
      transform: "translate(-35.24 -28.87)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M214.76,443.58a9.38,9.38,0,0,0-12.13,5.34l-24.08,61.95A9.38,9.38,0,0,0,183.89,523a9.48,9.48,0,0,0,3.4.64,9.37,9.37,0,0,0,8.73-6l24.08-61.95A9.38,9.38,0,0,0,214.76,443.58Z",
      transform: "translate(-35.24 -28.87)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M365.31,447.36a9.38,9.38,0,0,0-17.16,7.56l26.79,60.82a9.36,9.36,0,0,0,8.58,5.6,9.2,9.2,0,0,0,3.77-.8,9.38,9.38,0,0,0,4.8-12.35Z",
      transform: "translate(-35.24 -28.87)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M524,362.86l-61.94-24.08a9.37,9.37,0,0,0-6.79,17.47l61.94,24.08a9.48,9.48,0,0,0,3.4.64A9.37,9.37,0,0,0,524,362.86Z",
      transform: "translate(-35.24 -28.87)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M457.52,211.52a9.2,9.2,0,0,0,3.77-.8l60.83-26.78a9.37,9.37,0,0,0-7.55-17.15l-60.83,26.78a9.37,9.37,0,0,0,3.78,18Z",
      transform: "translate(-35.24 -28.87)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M350.5,108.92a9.18,9.18,0,0,0,3.39.64,9.38,9.38,0,0,0,8.74-6L386.7,41.64a9.37,9.37,0,1,0-17.47-6.79L345.16,96.79A9.36,9.36,0,0,0,350.5,108.92Z",
      transform: "translate(-35.24 -28.87)"
    })]
  });
};
exports.Sun = Sun;
const Moon = function (_ref15) {
  let {
    title = "Moon Icon",
    ...props
  } = _ref15;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 328.94 339.08",
    ...props,
    "data-testid": "Moon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M209.38,364.09A170,170,0,0,1,58.31,271.68c-42.54-83.2-9.45-185.5,73.75-228A167.91,167.91,0,0,1,239,27.71l15.47,2.77-14.59,5.84c-3.73,1.49-7.38,3.14-10.85,4.92a127.47,127.47,0,1,0,116.06,227h0c3.47-1.77,6.95-3.76,10.33-5.91l13.28-8.41-6.81,14.16a169.8,169.8,0,0,1-152.5,96ZM208.87,34a159.09,159.09,0,0,0-72.71,17.64C57.37,91.94,26,188.8,66.32,267.58a160.5,160.5,0,0,0,280.23,10,136.48,136.48,0,0,1-181-60.7c-33.81-66.13-8.29-147.24,56.8-182.28C217.84,34.2,213.34,34,208.87,34Z",
          transform: "translate(-39.75 -25.01)"
        })
      })
    })]
  });
};
exports.Moon = Moon;
const Close = function (_ref16) {
  let {
    title = "Close Icon",
    ...props
  } = _ref16;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    ...props,
    "data-testid": "Close",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
          points: "13.2,12.5 24.8,24.1 24.5,24.5 24.2,24.8 12.5,13.2 0.8,24.8 0.5,24.5 0.2,24.1 11.8,12.5 0.2,0.8 0.5,0.5 0.8,0.1 12.5,11.8 24.2,0.1 24.5,0.5 24.8,0.8"
        })
      })
    })]
  });
};
exports.Close = Close;
const CloseHeavy = function (_ref17) {
  let {
    title = "Close Heavy Icon",
    ...props
  } = _ref17;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0.938 -0.063 9.781 9.813",
    enableBackground: "new 0.938 -0.063 9.781 9.813",
    ...props,
    "data-testid": "CloseHeavy",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
      points: "10.766,0.675 10.059,-0.032 5.867,4.16 1.675,-0.032 0.968,0.675 5.16,4.867 0.968,9.059 1.675,9.766 5.867,5.574\n10.059,9.766 10.766,9.059 6.574,4.867 "
    })]
  });
};
exports.CloseHeavy = CloseHeavy;
const CloseRounded = function (_ref18) {
  let {
    title = "Close Rounded Icon",
    ...props
  } = _ref18;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    "enable-background": "new 0.938 -0.063 9.781 9.813",
    ...props,
    "data-testid": "CloseRounded",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "m4.939 3.05 3.535 3.535L12.01 3.05a1 1 0 1 1 1.414 1.414L9.89 8l3.535 3.537a1 1 0 0 1-1.414 1.414L8.474 9.414 4.939 12.95a1 1 0 0 1-1.414-1.414L7.06 7.999 3.525 4.464A1 1 0 1 1 4.939 3.05z",
      fill: "#000"
    })]
  });
};
exports.CloseRounded = CloseRounded;
const Pin = function (_ref19) {
  let {
    title = "Pin Icon",
    ...props
  } = _ref19;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.SVG, {
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 10.8 14.4",
    width: "10.8px",
    height: "14.4px",
    ...props,
    "data-testid": "Pin",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M5.4,0C2.4,0,0,2.4,0,5.4s5.4,9,5.4,9s5.4-6,5.4-9S8.4,0,5.4,0z M5.4,7.2c-1.2,0-2.1-0.9-2.1-2.1S4.2,3,5.4,3\ns2.1,0.9,2.1,2.1S6.6,7.2,5.4,7.2z"
    })
  });
};
exports.Pin = Pin;
const PinAlternate = function (_ref20) {
  let {
    fill = "#010101",
    title = "Pin",
    ...props
  } = _ref20;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.8 21",
    fill: fill,
    ...props,
    "data-testid": "PinAlternate",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M8.4,6.3a2.1,2.1,0,1,0,2.1,2.1A2.11,2.11,0,0,0,8.4,6.3Z",
      transform: "translate(0)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M8.4,0A8.35,8.35,0,0,0,0,8.61Q0,13.85,8.4,21q8.4-7.17,8.4-12.39A8.35,8.35,0,0,0,8.4,0Zm0,18.21c-4.25-3.89-6.3-7.14-6.3-9.6A6.25,6.25,0,0,1,8.4,2.1a6.25,6.25,0,0,1,6.3,6.51C14.7,11.07,12.65,14.32,8.4,18.21Z",
      transform: "translate(0)"
    })]
  });
};
exports.PinAlternate = PinAlternate;
const PinStar = function (_ref21) {
  let {
    title = "Pin Icon",
    fill = "#000",
    ...props
  } = _ref21;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    width: "16",
    height: "16",
    ...props,
    "data-testid": "PinStar",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.41703 8.14957C8.35769 8.11743 8.28788 8.10137 8.22244 8.10137C8.15612 8.10137 8.08719 8.11386 8.02698 8.14957L6.43712 8.94042L6.67883 7.14984C6.69803 7.01149 6.65091 6.87045 6.55928 6.77048L5.33678 5.46548L7.07847 5.14682C7.21373 5.1245 7.32978 5.03792 7.39523 4.91206L8.22855 3.31785L9.061 4.91206C9.12732 5.03435 9.24337 5.12093 9.37862 5.14682L11.1194 5.46548L9.88472 6.76691C9.78699 6.87313 9.74598 7.01149 9.76518 7.14627L10.0069 8.93685L8.41703 8.14957ZM7.90482 15.868C7.99295 15.9581 8.10551 16.0001 8.22244 16.0001C8.335 16.0001 8.45193 15.9581 8.53046 15.868C9.93795 14.4246 13.0051 10.8051 13.7878 9.21087C14.225 8.32629 14.4449 7.36495 14.4449 6.36522C14.4449 4.66747 13.7974 3.06702 12.622 1.86467C11.4502 0.662319 9.88123 0 8.22244 0C4.79054 0 2 2.85458 2 6.36879C2 7.36852 2.21989 8.32272 2.65619 9.21355C3.4293 10.8051 6.49384 14.4246 7.90482 15.868Z",
      fill: fill
    })]
  });
};
exports.PinStar = PinStar;
const LocateStroke = function (_ref22) {
  let {
    title = "Pin",
    fill,
    ...props
  } = _ref22;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "36",
    height: "42",
    viewBox: "0 0 36 42",
    fill: fill,
    ...props,
    "data-testid": "LocateStroke",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M24 12H12V24H24V12Z",
      fill: "#E10A1D"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M19.9799 0.0930001C19.3289 0.0300001 18.6689 0 17.9999 0C17.3309 0 16.6709 0.0300001 16.0199 0.0930001C1.53594 1.446 -4.33806 19.665 5.94894 29.952L17.9999 42L30.0509 29.949C40.3349 19.665 34.4639 1.446 19.9799 0.0930001ZM27.9299 27.828L17.9999 37.758L8.06995 27.828C3.98395 23.739 2.68194 17.769 4.67394 12.243C6.56095 7.008 10.9079 3.582 16.3019 3.078C16.8599 3.027 17.4269 3 17.9999 3C18.5729 3 19.1399 3.027 19.7009 3.078C25.0949 3.582 29.4389 7.008 31.3289 12.243C33.3179 17.769 32.0159 23.739 27.9299 27.828Z",
      fill: "black"
    })]
  });
};
exports.LocateStroke = LocateStroke;
const ToyotaPinZip = function (_ref23) {
  let {
    title = "Pin",
    fill,
    ...props
  } = _ref23;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 36 42",
    fill: fill,
    ...props,
    "data-testid": "ToyotaPinZip",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M24 12H12V24H24V12Z",
      fill: "black"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M19.9799 0.0930001C19.3289 0.0300001 18.6689 0 17.9999 0C17.3309 0 16.6709 0.0300001 16.0199 0.0930001C1.53594 1.446 -4.33806 19.665 5.94894 29.952L17.9999 42L30.0509 29.949C40.3349 19.665 34.4639 1.446 19.9799 0.0930001ZM27.9299 27.828L17.9999 37.758L8.06995 27.828C3.98395 23.739 2.68194 17.769 4.67394 12.243C6.56095 7.008 10.9079 3.582 16.3019 3.078C16.8599 3.027 17.4269 3 17.9999 3C18.5729 3 19.1399 3.027 19.7009 3.078C25.0949 3.582 29.4389 7.008 31.3289 12.243C33.3179 17.769 32.0159 23.739 27.9299 27.828Z",
      fill: "black"
    })]
  });
};
exports.ToyotaPinZip = ToyotaPinZip;
const ZipSearch = function (_ref24) {
  let {
    title = "Zip Search Icon",
    ...props
  } = _ref24;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    height: "50",
    width: "50",
    ...props,
    "data-testid": "ZipSearch",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M 32.21 30.49 L 28.56 26.83 C 30.23 24.65 30.04 21.5 28.09 19.54 C 27.05 18.49 25.66 17.92 24.19 17.92 C 22.72 17.92 21.33 18.5 20.29 19.54 C 18.14 21.7 18.14 25.21 20.29 27.37 C 21.33 28.42 22.72 28.99 24.19 28.99 C 25.42 28.99 26.62 28.57 27.59 27.81 L 31.23 31.47 C 31.36 31.6 31.53 31.67 31.72 31.67 C 31.91 31.67 32.08 31.6 32.21 31.47 C 32.48 31.2 32.48 30.76 32.21 30.49 Z M 27.12 26.39 C 26.34 27.18 25.3 27.61 24.19 27.61 C 23.09 27.61 22.05 27.18 21.27 26.39 C 19.66 24.77 19.66 22.13 21.27 20.51 C 22.05 19.73 23.09 19.29 24.19 19.29 C 25.29 19.29 26.33 19.72 27.12 20.51 C 28.74 22.13 28.74 24.77 27.12 26.39 Z"
        })
      })
    })]
  });
};
exports.ZipSearch = ZipSearch;
const LexusPin = function (_ref25) {
  let {
    title = "Lexus Pin Icon",
    ...props
  } = _ref25;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "12.5 12.5 24 35",
    ...props,
    "data-testid": "LexusPin",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M29.97,14.59c-2.74-2.75-7.2-2.75-9.94,0c-2.11,2.11-2.59,5.22-1.47,7.79l6.32,15.08l6.7-15.39 C32.53,19.57,32,16.62,29.97,14.59z M28.58,21.14c-0.04,0.04-0.12,0.07-0.24,0.08c-0.06,0-3.57,0.04-4.13-0.01 c-0.25-0.02-0.56-0.06-0.81-0.22c-0.17-0.1-0.31-0.33-0.31-0.57c0-0.26,0.05-0.34,0.19-0.65c0.15-0.35,1.7-2.37,1.81-2.49 c0.24-0.27,0.08-0.31,0-0.31c-0.03,0-0.18,0-0.21,0c-2.13,0.06-3.33,1.42-3.31,2.68c0.02,1.54,1.5,2.65,3.58,2.59 c1.09-0.04,2.01-0.31,2.58-0.84l0.69-0.02c-0.48,0.63-1.74,1.21-3.29,1.24c-2.72,0.05-4.17-1.42-4.2-2.87 c-0.03-1.7,1.49-3.1,4.01-3.11c0.58,0,0.99,0.04,1.47,0.14c0.31,0.06,0.33,0.21,0.25,0.32c-0.07,0.11-1.89,2.29-2.2,3.02 c-0.17,0.4,0.21,0.37,0.36,0.39c0.49,0.04,2.75,0.07,3.29,0.03c0.21-0.01,0.29-0.3,0.32-0.39c0.03-0.12,0.06-0.34,0.06-0.5 c0.01-1.16-0.71-2.03-1.73-2.43l0.22-0.28c1.1,0.42,2.13,1.38,2.13,2.72C29.08,20.22,28.9,20.85,28.58,21.14z"
    })]
  });
};
exports.LexusPin = LexusPin;
const MilitaryIcon = function (_ref26) {
  let {
    title = "Military Icon",
    ...props
  } = _ref26;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "51.2 192.8 498.399 396.2",
    ...props,
    "data-testid": "MilitaryIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M300.9,589c-49.3-27.6-98.4-55.1-147.9-82.9c0-6.399,0-12.5,0-19.5c-34.1,0-67.5,0-100.9,0c-0.3-0.6-0.6-1.1-0.9-1.699 c11.8-14.2,23.5-28.5,35.6-43C75.7,426.2,64.6,410.6,53,394.2c29.1,0,57.2,0,86,0c0-10.3,0-20,0-30.4c4.9,0,9.2,0,14,0 c0-41.4,0-83.6,0-124.9c4-1.3,7.2-2.5,10.5-3.5c44.1-14,132-41.7,137-42.6c4.8,0.7,145.2,45.3,147.5,46.1c0,41.2,0,122.3,0,124.6 c2.6,0,7,0.1,10.8,0.1c0,10.2,0,20.1,0,30.4c29.4,0,58.101,0,88.101,0c-11.601,16.3-22.601,31.8-34,47.8 C524.8,456.2,536.7,470.4,549.6,485.9c-34.5,0-67.5,0-101.3,0c0,7.3,0,13.699,0,20.199C399,534.1,350,561.5,300.9,589z M414.5,263.7c-13.3-4.2-103.5-32.5-113.9-35.4c-4,1-110.1,34.2-113,35.5c0,1.7,0,66.1,0,99c75.9,0,151.2,0,226.9,0 C414.5,329.5,414.5,296.8,414.5,263.7z M300.9,550.4c38.2-21.4,76-42.5,113.4-63.5c0-11.801,0-23,0-34.301c-75.899,0-151.3,0-227,0 c0,11.601,0,22.7,0,34.2C225,507.8,262.7,529,300.9,550.4z M166.7,424.5c88.6,0,176.7,0,265,0c0-11.5,0-22.4,0-33.7 c-88.5,0-176.6,0-265,0C166.7,402.3,166.7,413.4,166.7,424.5z M494.3,421.6c-12.399,0-23.399,0-35.3,0c0,10.2,0,19.9,0,29.9 c-3.9,0-6.7,0-10,0c0,2.5-0.1,5.4-0.1,7.6c14.399,0,28.199,0,43.199,0c-4.699-5.8-8.8-10.899-13-16 C484.1,436,488.9,429.3,494.3,421.6z M108.2,458.9c15.3,0,29.6,0,44.6,0c0-2.601,0-4.301,0-6.5c-4.6,0-8.9,0-13.7,0 c0-10.301,0-20.7,0-30.7c-11.3,0-21.8,0-33.3,0c5.5,7.7,10.3,14.6,15.2,21.5C116.6,448.5,112.6,453.5,108.2,458.9z"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M300.5,192.9"
    })]
  });
};
exports.MilitaryIcon = MilitaryIcon;
const CollegeIcon = function (_ref27) {
  let {
    title = "College Icon",
    ...props
  } = _ref27;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 204.721 612 382.557",
    ...props,
    "data-testid": "CollegeIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M612,343.123c-0.46-0.46-0.46-0.919-0.92-0.919L302.092,204.721c-0.46,0-0.46,0-0.92,0l0,0c-0.459,0-0.459,0-0.919,0\nL1.839,334.846c-1.379,0.459-1.839,2.299-0.92,3.678c0.46,0.46,0.46,0.919,0.92,0.919l46.44,20.231v74.949\nc0,8.276,5.058,15.633,12.415,18.852l61.154,27.129v106.674h36.785v-90.581l137.481,61.154h0.46\nc2.299,0.919,5.058,1.379,7.816,1.379s5.518-0.46,8.276-1.839l240.019-104.376c7.816-3.219,12.874-10.575,12.874-18.852v-68.511\nl45.521-19.312C612,345.881,612.46,344.502,612,343.123z M301.172,254.84l199.096,88.283l-193.118,80.925l-81.845-36.324\nl77.707-32.187l-13.794-34.025l-110.813,45.521l-68.051-29.887L301.172,254.84z M85.064,424.048v-47.819l36.784,16.093v47.82\nL85.064,424.048z M528.315,424.048l-223.925,97.479l-145.758-64.832v-40.923l8.276-3.219l139.32,61.154c0.46,0.46,1.38,0.46,2.3,0\nl220.246-92.421v42.762H528.315z"
    })]
  });
};
exports.CollegeIcon = CollegeIcon;
const InfoIcon = function (_ref28) {
  let {
    title = "Info Icon",
    iconText = "#FFFFFF",
    fill = "black",
    ...props
  } = _ref28;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    role: "presentation",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    fill: fill,
    ...props,
    "data-testid": "InfoIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "10",
        cy: "10",
        r: "10"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: iconText,
        d: "M8.8,7.1V4.9h2.5v2.3L8.8,7.1L8.8,7.1z M8.8,15.1V8.2h2.5v6.9H8.8z"
      })
    })]
  });
};
exports.InfoIcon = InfoIcon;
const InfoIconSlim = function (_ref29) {
  let {
    title = "Info Icon",
    iconText = "#000",
    fill = "none",
    ...props
  } = _ref29;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    role: "presentation",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    fill: fill,
    ...props,
    "data-testid": "InfoIconSlim",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: "9.45715",
      cy: "9",
      r: "8",
      stroke: iconText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M9.47225 6.908C8.94425 6.908 8.54825 6.5 8.54825 5.984C8.54825 5.468 8.94425 5.072 9.47225 5.072C9.98825 5.072 10.3842 5.468 10.3842 5.984C10.3842 6.5 9.98825 6.908 9.47225 6.908ZM8.70425 14V7.928H10.2042V14H8.70425Z",
      fill: iconText
    })]
  });
};
exports.InfoIconSlim = InfoIconSlim;
const InfoIconThick = function (_ref30) {
  let {
    title = "Info Icon",
    iconText = "#000",
    fill = "none",
    ...props
  } = _ref30;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    role: "presentation",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    fill: fill,
    ...props,
    "data-testid": "InfoIconThick",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: "8",
      cy: "8",
      r: "7",
      stroke: iconText,
      "stroke-width": "2"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
      x1: "8",
      y1: "7",
      x2: "8",
      y2: "12",
      stroke: iconText,
      "stroke-width": "2"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: "8",
      cy: "5",
      r: "1",
      fill: iconText
    })]
  });
};
exports.InfoIconThick = InfoIconThick;
const LexusPhoneIcon = function (_ref31) {
  let {
    title = "Lexus Phone",
    iconText = "#000",
    fill = "none",
    ...props
  } = _ref31;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    role: "presentation",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13 20",
    fill: fill,
    ...props,
    "data-testid": "LexusPhoneIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.2528 2C11.2528 1.44771 10.8051 1 10.2528 1H2.63965C2.08736 1 1.63965 1.44772 1.63965 2V17.9999C1.63965 18.5521 2.08736 18.9999 2.63965 18.9999H10.2528C10.8051 18.9999 11.2528 18.5521 11.2528 17.9999V2Z",
      stroke: iconText,
      "stroke-width": "1.048"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M5.03711 2.1983L7.85583 2.1983",
      stroke: iconText,
      "stroke-linecap": "round"
    })]
  });
};
exports.LexusPhoneIcon = LexusPhoneIcon;
const ToyotaPhoneIcon = function (_ref32) {
  let {
    title = "Toyota Phone",
    iconText = "#000",
    fill = "none",
    ...props
  } = _ref32;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    role: "presentation",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 11",
    fill: fill,
    ...props,
    "data-testid": "ToyotaPhoneIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.2108 2.64929C1.34402 1.59543 1.82525 1.15195 2.67818 0.830369C3.14195 0.655516 3.77623 1.32341 4.0747 1.66028C4.37317 1.99716 4.66639 2.59194 4.66832 2.70719C4.67411 3.05294 4.33608 3.50815 3.88279 3.96143C3.49089 4.35333 4.45097 5.65745 5.21575 6.4276C5.98053 7.19775 7.26534 8.12778 7.65724 7.73588C8.11052 7.2826 8.56574 6.94456 8.91149 6.95035C9.02674 6.95228 9.62152 7.2455 9.95839 7.54397C10.2953 7.84245 10.9632 8.47673 10.7883 8.94049C10.4667 9.79343 10.0232 10.2746 8.96938 10.4079C7.35973 10.6114 5.12742 9.07788 3.73872 7.67027C2.81291 6.73186 1.00732 4.25894 1.2108 2.64929Z",
      fill: iconText
    })]
  });
};
exports.ToyotaPhoneIcon = ToyotaPhoneIcon;
const StandardIcon = function (_ref33) {
  let {
    fill = "#666",
    title = "Standard Icon",
    ...props
  } = _ref33;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/Styled.SVG",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 12",
    style: {
      enableBackground: "new 0 0 16 12"
    },
    xmlSpace: "preserve",
    fill: fill,
    ...props,
    "data-testid": "StandardIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
        points: "5.5,11.4 0.6,6.6 1.4,5.8 5.5,10 14.6,0.9 15.4,1.7 \t"
      })
    })]
  });
};
exports.StandardIcon = StandardIcon;
const PackageIcon = function (_ref34) {
  let {
    fill = "#666",
    title = "Package Icon",
    ...props
  } = _ref34;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 19",
    style: {
      enableBackground: "new 0 0 19 19"
    },
    xmlSpace: "preserve",
    fill: fill,
    ...props,
    "data-testid": "PackageIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M9.3,10.4h-1v3.5H6.4V5.1h2.9c2,0,3.2,0.9,3.2,2.6C12.6,9.4,11.3,10.4,9.3,10.4z M9.3,6.7h-1v2h1 c0.9,0,1.3-0.3,1.3-1S10.2,6.7,9.3,6.7z"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M19,19H0V0h19V19z M1,18h17V1H1V18z"
      })
    })]
  });
};
exports.PackageIcon = PackageIcon;
const OptionalIcon = function (_ref35) {
  let {
    fill = "#666",
    title = "Optional Icon",
    ...props
  } = _ref35;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 19",
    style: {
      enableBackground: "new 0 0 19 19"
    },
    xmlSpace: "preserve",
    fill: fill,
    ...props,
    "data-testid": "OptionalIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m9.5 14c-2.7 0-4.5-2-4.5-4.5 0-2.6 1.8-4.5 4.5-4.5s4.5 1.9 4.5 4.5c0 2.5-1.8 4.5-4.5 4.5zm0-7.3c-1.5 0-2.5 1.3-2.5 2.8 0 1.6 1.2 2.9 2.5 2.9 1.6 0 2.5-1.4 2.5-2.9 0-1.6-1-2.8-2.5-2.8z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m19 19h-19v-19h19zm-18-1h17v-17h-17z"
      })]
    })]
  });
};
exports.OptionalIcon = OptionalIcon;
const FinancialIcon = function (_ref36) {
  let {
    fill = "#666",
    title = "Financial Icon",
    ...props
  } = _ref36;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.76 25.75",
    style: {
      enableBackground: "new 0 0 23.76 25.75"
    },
    xmlSpace: "preserve",
    fill: fill,
    ...props,
    "data-testid": "FinancialIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M18.14,33.56H15.6A.56.56,0,0,1,15,33V22.2a.56.56,0,0,1,.56-.56h2.54a.57.57,0,0,1,.57.56V33A.57.57,0,0,1,18.14,33.56ZM15.6,22a.16.16,0,0,0-.16.16V33a.16.16,0,0,0,.16.16h2.54A.16.16,0,0,0,18.3,33V22.2a.16.16,0,0,0-.16-.16Z",
        transform: "translate(-13.53 -11.91)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M23.84,33.56H21.3a.57.57,0,0,1-.57-.56V22.2a.57.57,0,0,1,.57-.56h2.54a.56.56,0,0,1,.56.56V33A.56.56,0,0,1,23.84,33.56ZM21.3,22a.17.17,0,0,0-.17.16V33a.17.17,0,0,0,.17.16h2.54A.16.16,0,0,0,24,33V22.2a.16.16,0,0,0-.16-.16Z",
        transform: "translate(-13.53 -11.91)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M29.84,33.56H27.31a.57.57,0,0,1-.57-.56V22.2a.57.57,0,0,1,.57-.56h2.53a.56.56,0,0,1,.57.56V33A.56.56,0,0,1,29.84,33.56ZM27.31,22a.17.17,0,0,0-.17.16V33a.17.17,0,0,0,.17.16h2.53A.17.17,0,0,0,30,33V22.2a.17.17,0,0,0-.17-.16Z",
        transform: "translate(-13.53 -11.91)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M35.36,33.56H32.74c-.08,0-.49-.24-.49-.55V22.2a.57.57,0,0,1,.57-.56h2.54a.56.56,0,0,1,.56.56V33A.56.56,0,0,1,35.36,33.56Zm-2.49-.4h2.49a.16.16,0,0,0,.16-.16V22.2a.16.16,0,0,0-.16-.16H32.82a.17.17,0,0,0-.17.16V33A.64.64,0,0,0,32.87,33.16Z",
        transform: "translate(-13.53 -11.91)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M36.68,37.67H14.15a.62.62,0,0,1-.62-.62V35.17a.61.61,0,0,1,.62-.61H36.68a.61.61,0,0,1,.62.61v1.88A.62.62,0,0,1,36.68,37.67ZM14.15,35.06a.12.12,0,0,0-.12.11v1.88a.12.12,0,0,0,.12.12H36.68a.12.12,0,0,0,.12-.12V35.17a.12.12,0,0,0-.12-.11Z",
        transform: "translate(-13.53 -11.91)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M36.57,20.38H14.26a.73.73,0,0,1-.73-.73v-2a1.08,1.08,0,0,1,.59-.91L24.92,12A1.49,1.49,0,0,1,26,12l10.71,4.74a1.08,1.08,0,0,1,.59.91v2A.73.73,0,0,1,36.57,20.38Zm-11.11-8a.9.9,0,0,0-.34.06l-10.8,4.75a.56.56,0,0,0-.29.45v2a.23.23,0,0,0,.23.23H36.57a.23.23,0,0,0,.23-.23v-2a.56.56,0,0,0-.29-.45L25.8,12.47A.86.86,0,0,0,25.46,12.41Z",
        transform: "translate(-13.53 -11.91)"
      })]
    })]
  });
};
exports.FinancialIcon = FinancialIcon;
const ErrorIcon = function (_ref37) {
  let {
    fill = "#666",
    title = "Error Icon",
    ...props
  } = _ref37;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.07 24.1",
    style: {
      enableBackground: "new 0 0 28.07 24.1"
    },
    xmlSpace: "preserve",
    fill: fill,
    ...props,
    "data-testid": "ErrorIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M37.51,36.85H13.3a1.86,1.86,0,0,1-1.68-1,2.15,2.15,0,0,1,.13-2.19l.05-.07,12-20.21a2.27,2.27,0,0,1,3.14,0l.07.1,12,20.18a2.14,2.14,0,0,1,.16,2.2A1.9,1.9,0,0,1,37.51,36.85ZM24.58,14.05l-12,20.22a1.18,1.18,0,0,0,0,1.11.86.86,0,0,0,.8.47H37.51a.88.88,0,0,0,.82-.46,1.15,1.15,0,0,0-.07-1.13l-.07-.09-12-20.12A1.26,1.26,0,0,0,24.58,14.05Z",
        transform: "translate(-11.38 -12.75)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        x: "13.17",
        y: "9.31",
        width: "1.73",
        height: "5.94"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        x: "13.17",
        y: "17.24",
        width: "1.73",
        height: "1.94"
      })]
    })]
  });
};
exports.ErrorIcon = ErrorIcon;
const PointInspection = function (_ref38) {
  let {
    fill = "#666",
    title = "Point Inspection Icon",
    ...props
  } = _ref38;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.1 18.8",
    style: {
      enableBackground: "new 0 0 19.1 18.8"
    },
    xmlSpace: "preserve",
    fill: fill,
    ...props,
    "data-testid": "PointInspection",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M35,17.65l-3.33-2.26-3.32,4H15.86V34.19h14.8V23.52l4.19-5.7Zm-4.81,16H16.36V19.9H27.91l-4.3,5.19-3.26-2.26-3.11,3.83,7.09,5.47,5.83-7.93Zm-5.91-2.13-6.44-5,2.61-3.23,3.26,2.26,8-9.71,2.68,1.83Z",
        transform: "translate(-15.86 -15.39)"
      })
    })]
  });
};
exports.PointInspection = PointInspection;
const FuelPump = function (_ref39) {
  let {
    fill = "#666",
    title = "Fuel Pump Icon",
    ...props
  } = _ref39;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.74 24.56",
    style: {
      enableBackground: "new 0 0 19.74 24.56"
    },
    xmlSpace: "preserve",
    fill: fill,
    ...props,
    "data-testid": "FuelPump",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "cls-1",
        d: "M26.24,16.13h-6a1,1,0,0,0-1,1v3.83a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V17.1A1,1,0,0,0,26.24,16.13Zm.51,4.8a.5.5,0,0,1-.51.5h-6a.5.5,0,0,1-.5-.5V17.1a.5.5,0,0,1,.5-.5h6a.51.51,0,0,1,.51.5Z",
        transform: "translate(-17.22 -13.89)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "cls-1",
        d: "M36.82,34.81l-1.54-6.93V20.06c0-1.55-1.37-2.83-2.11-3.52l-2.05-1.95-.49.51,1.59,1.51a.25.25,0,0,1,.06.14v2.81c0,.92.23,2,2.12,2.19a.21.21,0,0,1,.18.2v5.94L36.15,35a1.77,1.77,0,0,1,.1.61,1.89,1.89,0,0,1-3.78,0V25.83a2.07,2.07,0,0,0-2.07-2.07H29.25V16.38a2.48,2.48,0,0,0-2.49-2.49h-7a2.49,2.49,0,0,0-2.49,2.49V38.45h.55V16.38a1.94,1.94,0,0,1,1.94-1.94h7.05a1.94,1.94,0,0,1,1.94,1.94V38.45h.55v-14h1.16a1.36,1.36,0,0,1,1.36,1.36v9.82a2.6,2.6,0,1,0,5.19,0A2.51,2.51,0,0,0,36.82,34.81ZM34.49,20.75a.19.19,0,0,1-.07.15.19.19,0,0,1-.13.05h0c-1.19-.17-1.19-.85-1.19-1.39V18a.19.19,0,0,1,.13-.18l.07,0a.21.21,0,0,1,.15.07,3.35,3.35,0,0,1,1.07,2.15Z",
        transform: "translate(-17.22 -13.89)"
      })]
    })]
  });
};
exports.FuelPump = FuelPump;
const FuelPumpAlternate = function (_ref40) {
  let {
    fill = "transparent",
    stroke = "#000",
    title = "Fuel Pump Icon",
    ...props
  } = _ref40;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    ...props,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "data-testid": "FuelPumpAlternate",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15.1596 3.01801L15.3266 21.931H4.13965V3.19101L15.1596 3.01801Z",
      stroke: stroke
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M15.8269 13.338H18.8299V18.891C18.8299 19.493 19.3119 19.98 19.9069 19.98C20.5029 19.98 20.9859 19.493 20.9859 18.891V9.90603L19.7469 7.46103H17.9069M6.83789 10.223H12.6289V5.74603H6.83789V10.223Z",
      stroke: stroke,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M18.9004 7.461V11.061H20.9844",
      stroke: stroke,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })]
  });
};
exports.FuelPumpAlternate = FuelPumpAlternate;
const FuelPumpAlternateElectric = function (_ref41) {
  let {
    fill = "#000",
    title = "Fuel Pump Icon Electric",
    ...props
  } = _ref41;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    ...props,
    fill: fill,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "FuelPumpAlternateElectric",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      "clip-path": "url(#clip0_2002_1775)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M23.5 7.5V10.5C23.5042 10.9478 23.4014 11.39 23.2 11.79C22.9543 12.2972 22.5708 12.725 22.0933 13.0243C21.6157 13.3236 21.0636 13.4823 20.5 13.4823C19.9364 13.4823 19.3843 13.3236 18.9067 13.0243C18.4292 12.725 18.0457 12.2972 17.8 11.79C17.5986 11.39 17.4958 10.9478 17.5 10.5V7.5H23.5Z",
        fill: "transparent",
        stroke: "black",
        "stroke-miterlimit": "10"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M18.5 4V7",
        stroke: "black",
        "stroke-miterlimit": "10"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M22.5 4V7",
        stroke: "black",
        "stroke-miterlimit": "10"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M8 4V7H4V4H8ZM9 3H3V8H9V3Z",
        fill: fill
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M12 16.5H20.5",
        stroke: "black",
        "stroke-miterlimit": "10"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M20.5 13.5V17",
        stroke: "black",
        "stroke-miterlimit": "10"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M8 15L5 19V16H4V12H8L6 15H8Z",
        fill: "black"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M10 1C10.2652 1 10.5196 1.10536 10.7071 1.29289C10.8946 1.48043 11 1.73478 11 2V23H1V2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1H10ZM10 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2L0 24H12V2C12 1.46957 11.7893 0.960859 11.4142 0.585786C11.0391 0.210714 10.5304 0 10 0Z",
        fill: "black"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "clip0_2002_1775",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      })
    })]
  });
};
exports.FuelPumpAlternateElectric = FuelPumpAlternateElectric;
const Engine = function (_ref42) {
  let {
    fill = "transparent",
    stroke = "#000",
    title = "Engine Icon",
    ...props
  } = _ref42;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    ...props,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "data-testid": "Engine",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M6.09002 4.98602H16.681M11.385 4.98602V8.18802M1.24902 16.502V10.133M1.24902 13.318H4.44002M20.689 8.99502L18.912 10.779H16.681V8.18802H6.09002V9.95602H4.43902V16.722H6.11802L8.95202 19.566H16.681V16.975H18.912L20.689 18.759H22.625V13.877V8.99502H20.689Z",
      stroke: stroke,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })]
  });
};
exports.Engine = Engine;
const EngineElectric = function (_ref43) {
  let {
    fill = "#000",
    title = "Fuel Pump Icon Electric",
    ...props
  } = _ref43;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    ...props,
    fill: fill,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "EngineElectric",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      "clip-path": "url(#clip0_801_20678)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        "clip-path": "url(#clip1_801_20678)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M17 20H4.47L0 15.42V4H12.21L16.44 9H19V4H22C22.5174 4.03917 23.0037 4.26246 23.3706 4.62939C23.7375 4.99631 23.9608 5.48257 24 6V16.07C23.9612 16.5809 23.736 17.0598 23.3673 17.4156C22.9986 17.7714 22.512 17.9794 22 18H19V13H17V20ZM4.89 19H16V12H20V17H22C22.2425 16.9678 22.469 16.861 22.6482 16.6944C22.8274 16.5277 22.9503 16.3096 23 16.07V6C23 5.53 22.31 5 22 5H20V10H16L11.78 5H1V15L4.89 19Z",
          fill: "black"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M8 11L5 15V12H4V8H8L6 11H8Z",
          fill: "black"
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "clip0_801_20678",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          width: "23.9264",
          height: "24",
          fill: "white"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "clip1_801_20678",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          width: "24",
          height: "16",
          fill: "white",
          transform: "translate(0 4)"
        })
      })]
    })]
  });
};
exports.EngineElectric = EngineElectric;
const Mileage = function (_ref44) {
  let {
    fill = "transparent",
    stroke = "#000",
    title = "Mileage",
    ...props
  } = _ref44;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    ...props,
    fill: fill,
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "Mileage",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M23.4546 16.9418C23.4546 13.9428 22.287 11.1236 20.1662 9.00286C18.0454 6.88209 15.2258 5.71448 12.2273 5.71448C9.22879 5.71448 6.40868 6.88209 4.28838 9.00286C2.16761 11.1232 1 13.9428 1 16.9418",
      stroke: stroke,
      "stroke-width": "1.12273",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M23.4554 16.9418H21.0918",
      stroke: stroke,
      "stroke-width": "1.12273",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M3.36364 16.9418H1",
      stroke: stroke,
      "stroke-width": "1.12273",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M19.9069 9.25977L18.1342 10.4416",
      stroke: stroke,
      "stroke-width": "1.12273",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M12.2273 5.71448V8.07812",
      stroke: stroke,
      "stroke-width": "1.12273",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M4.54691 9.25977L5.72872 10.4416",
      stroke: stroke,
      "stroke-width": "1.12273",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M10.4551 16.9418C10.4551 15.9643 11.2503 15.1691 12.2278 15.1691C12.6309 15.1691 13.0028 15.3047 13.3009 15.532C13.3028 15.5335 13.3048 15.5355 13.3068 15.537C13.3078 15.5375 13.3088 15.538 13.3098 15.539C13.7297 15.8633 14.0005 16.3714 14.0005 16.9418C14.0005 17.9193 13.2053 18.7145 12.2278 18.7145C11.8228 18.7145 11.4489 18.5774 11.1498 18.3476C11.1478 18.3461 11.1458 18.3441 11.1439 18.3426L11.1394 18.3397C10.7235 18.0148 10.4551 17.5093 10.4551 16.9418Z",
      fill: stroke
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M13.0399 15.3666C12.7963 15.2404 12.5205 15.1691 12.2278 15.1691M12.2278 15.1691C11.2503 15.1691 10.4551 15.9643 10.4551 16.9418M12.2278 15.1691C12.6309 15.1691 13.0028 15.3047 13.3009 15.532C13.3028 15.5335 13.3048 15.5355 13.3068 15.537C13.3078 15.5375 13.3088 15.538 13.3098 15.539C13.7297 15.8633 14.0005 16.3714 14.0005 16.9418C14.0005 17.9193 13.2053 18.7145 12.2278 18.7145C11.8228 18.7145 11.4489 18.5774 11.1498 18.3476C11.1478 18.3461 11.1458 18.3441 11.1439 18.3426C11.1424 18.3417 11.1409 18.3407 11.1394 18.3397C10.7235 18.0148 10.4551 17.5093 10.4551 16.9418M10.4551 16.9418C10.4551 17.3974 10.6279 17.8133 10.9116 18.1277",
      stroke: stroke,
      "stroke-width": "1.12273",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M13.1904 15.5923L15.9922 12.3818",
      stroke: stroke,
      "stroke-width": "1.12273",
      "stroke-linecap": "square",
      "stroke-linejoin": "round"
    })]
  });
};
exports.Mileage = Mileage;
const Box = function (_ref45) {
  let {
    fill = "transparent",
    stroke = "#000",
    title = "Box Icon",
    ...props
  } = _ref45;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    ...props,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "data-testid": "Box",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.2442 1.058L22.6942 6.268C22.8982 6.368 23.0002 6.565 23.0002 6.761V17.227C23.0002 17.437 22.8822 17.629 22.6952 17.722L12.2692 22.942C12.1802 22.986 12.0892 23.004 12.0002 22.999C11.9122 23.004 11.8202 22.986 11.7312 22.942L1.30518 17.722C1.11818 17.63 1.00018 17.437 1.00018 17.227V6.777C0.995177 6.576 1.09618 6.371 1.30518 6.267L11.7552 1.057C11.9102 0.981 12.0902 0.981 12.2452 1.057L12.2442 1.058ZM21.9032 7.684L12.5732 12.354V21.554L21.9032 16.884V7.684ZM2.09718 7.684V16.884L11.4272 21.554V12.354L2.09718 7.684ZM12.0002 2.17L2.78718 6.762L12.0002 11.355L21.2132 6.762L12.0002 2.169V2.17Z",
      fill: stroke
    })]
  });
};
exports.Box = Box;
const Details = function (_ref46) {
  let {
    fill = "transparent",
    stroke = "#000",
    title = "Details Icon",
    ...props
  } = _ref46;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    ...props,
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "data-testid": "Details",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M22.4764 5.52399H1.52441V20.476H22.4764V5.52399V5.52399Z",
      stroke: stroke,
      "stroke-width": "1.048"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.99707 8.23199H10.2831V11.451H3.99707V8.23199ZM3.99707 13.565H11.3301V17.851H3.99707V13.565Z",
      stroke: stroke,
      "stroke-width": "1.048"
    })]
  });
};
exports.Details = Details;
const Plus = function (props, _ref47) {
  let {
    title = "Plus Icon"
  } = _ref47;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "21",
    height: "21",
    viewBox: "0 0 21 21",
    ...props,
    "data-testid": "Plus",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: props.fill,
      d: "M21 10H11V0h-1v10H0v1h10v10h1V11h10v-1z"
    })]
  });
};
exports.Plus = Plus;
const Minus = function (props, _ref48) {
  let {
    title = "Minus Icon"
  } = _ref48;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "21",
    height: "21",
    viewBox: "0 0 21 21",
    ...props,
    "data-testid": "Minus",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: props.fill,
      d: "M0 10h21v1H0z"
    })]
  });
};
exports.Minus = Minus;
const CaretUp = function (props, _ref49) {
  let {
    title = "Caret Up Icon"
  } = _ref49;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "21",
    height: "21",
    viewBox: "0 0 21 21",
    ...props,
    "data-testid": "CaretUp",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: props.fill,
      d: "M20.97 15.37l-.76.78-9.64-9.74L.8 16.06l-.78-.79L10.54 4.84l10.43 10.53z"
    })]
  });
};
exports.CaretUp = CaretUp;
const CaretDown = function (props, _ref50) {
  let {
    title = "Caret Down Icon"
  } = _ref50;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "21",
    height: "21",
    viewBox: "0 0 21 21",
    ...props,
    "data-testid": "CaretDown",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: props.fill,
      d: "M20.97 5.62l-.76-.78-9.64 9.74L.8 4.93l-.78.79 10.52 10.43L20.97 5.62z"
    })]
  });
};
exports.CaretDown = CaretDown;
const ToyotaCaretDown = function (props, _ref51) {
  let {
    title = "Caret Down Icon"
  } = _ref51;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "7",
    viewBox: "0 0 12 7",
    fill: "none",
    style: {
      minWidth: "12px"
    },
    ...props,
    "data-testid": "ToyotaCaretDown",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.53572 1.2545C2.1452 0.863981 1.51203 0.863981 1.12151 1.2545C0.730982 1.64503 0.730982 2.27819 1.12151 2.66872L5.33895 6.88617C5.34714 6.89495 5.35551 6.90363 5.36407 6.91218C5.75459 7.30271 6.38775 7.30271 6.77828 6.91219L11.0209 2.66954C11.4114 2.27902 11.4114 1.64585 11.0209 1.25533C10.6304 0.864806 9.99723 0.864806 9.60671 1.25533L6.07163 4.79041L2.53572 1.2545Z",
      fill: "black"
    })]
  });
};
exports.ToyotaCaretDown = ToyotaCaretDown;
const ToyotaCaretUp = function (props, _ref52) {
  let {
    title = "Caret Down Icon"
  } = _ref52;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "7",
    viewBox: "0 0 12 7",
    fill: "none",
    ...props,
    "data-testid": "ToyotaCaretUp",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.53572 5.6537C2.1452 6.04422 1.51203 6.04422 1.12151 5.6537C0.730982 5.26317 0.730982 4.63001 1.12151 4.23949L5.33895 0.022036C5.34714 0.0132507 5.35551 0.00458241 5.36407 -0.00397782C5.75459 -0.39451 6.38775 -0.39451 6.77828 -0.00397782L11.0209 4.23866C11.4114 4.62918 11.4114 5.26235 11.0209 5.65287C10.6304 6.0434 9.99723 6.0434 9.60671 5.65287L6.07163 2.11779L2.53572 5.6537Z",
      fill: "black"
    })]
  });
};
exports.ToyotaCaretUp = ToyotaCaretUp;
const ToyotaCaretRight = function (props, _ref53) {
  let {
    title = "Caret Down Icon"
  } = _ref53;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "11",
    viewBox: "0 0 8 11",
    fill: "none",
    ...props,
    "data-testid": "ToyotaCaretRight",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.58586 0.552659C2.19534 0.162135 1.56217 0.162135 1.17165 0.552659C0.781124 0.943183 0.781124 1.57635 1.17165 1.96687L4.70673 5.50195L1.17082 9.03786C0.780299 9.42838 0.780299 10.0615 1.17082 10.4521C1.56135 10.8426 2.19451 10.8426 2.58504 10.4521L6.80248 6.23463C6.81127 6.22645 6.81994 6.21807 6.8285 6.20951C7.21903 5.81899 7.21903 5.18582 6.8285 4.7953L2.58586 0.552659Z",
      fill: "black"
    })]
  });
};
exports.ToyotaCaretRight = ToyotaCaretRight;
const Certification = function (props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Image, {
    ...props,
    src: require("./png/certification.png"),
    alt: "Certification Icon",
    "data-testid": "Certification"
  });
};
exports.Certification = Certification;
const LexusLogo = function (props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Image, {
    ...props,
    src: require("./png/lexus_logo_english.png"),
    alt: "Lexus Logo Icon",
    "data-testid": "LexusLogo"
  });
};
exports.LexusLogo = LexusLogo;
const MaintenanceWrench = function (props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Image, {
    ...props,
    src: require("./png/complimentaryMaint.png"),
    alt: "Maintenance Wrench Icon",
    "data-testid": "MaintenanceWrench"
  });
};
exports.MaintenanceWrench = MaintenanceWrench;
const LoanerCar = function (props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Image, {
    ...props,
    src: require("./png/loaner.png"),
    alt: "LoanerCar Icon",
    "data-testid": "LoanerCar"
  });
};
exports.LoanerCar = LoanerCar;
const ProgramCompare = function (props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Image, {
    ...props,
    src: require("./png/programComparison.png"),
    alt: "Program Compare Icon",
    "data-testid": "ProgramCompare"
  });
};
exports.ProgramCompare = ProgramCompare;
const GasCan = function (props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Image, {
    ...props,
    src: require("./png/roadsideAssistance.png"),
    alt: "Gas Can Icon",
    "data-testid": "GasCan"
  });
};
exports.GasCan = GasCan;
const TravelBags = function (props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Image, {
    ...props,
    src: require("./png/tripInterruption.png"),
    alt: "Travel Bags Icon",
    "data-testid": "TravelBags"
  });
};
exports.TravelBags = TravelBags;
const WarrantyShield = function (props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Image, {
    ...props,
    src: require("./png/warranty.png"),
    alt: "Warranty Shield Icon",
    "data-testid": "WarrantyShield"
  });
};
exports.WarrantyShield = WarrantyShield;
const PlayButton = function (props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Image, {
    ...props,
    src: require("./png/playButton.png"),
    alt: "Play Button Icon",
    "data-testid": "PlayButton"
  });
};
exports.PlayButton = PlayButton;
const FacebookIcon = function (_ref54) {
  let {
    fill = "#666",
    title = "Facebook Icon",
    ...props
  } = _ref54;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "91.882 1914 14.118 14.174",
    style: {
      enableBackground: "new 0 0 19.74 24.56"
    },
    xmlSpace: "preserve",
    fill: fill,
    ...props,
    "data-testid": "FacebookIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: fill,
      d: "M104.734,1914H93.147c-0.43,0-1.265,0.838-1.265,1.271v11.631c0,0.432,0.835,1.271,1.265,1.271h6.034v-5.381                                    h-1.945v-1.945h1.945v-1.495c0-1.832,1.38-2.918,3.007-2.918c0.779,0,1.189,0.084,1.385,0.11v1.854h-1.38                                    c-0.885,0-1.05,0.439-1.05,1.06v1.391h2.456l-0.32,1.945h-2.136v5.381h3.591c0.431,0,1.266-0.839,1.266-1.271v-11.631                                    C106,1914.838,105.165,1914,104.734,1914z"
    })]
  });
};
exports.FacebookIcon = FacebookIcon;
const TwitterIcon = function (_ref55) {
  let {
    fill = "#666",
    title = "Twitter Icon",
    ...props
  } = _ref55;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 15",
    style: {
      enableBackground: "new 0 0 19.74 24.56"
    },
    xmlSpace: "preserve",
    fill: fill,
    ...props,
    "data-testid": "TwitterIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: fill,
      d: "M8.92704 6.425L14.5111 0.5H13.1879L8.33921 5.64459L4.4666 0.5H0L5.85615 8.27954L0 14.4928H1.32333L6.44364 9.05995L10.5334 14.4928H15L8.92671 6.425H8.92704ZM7.11456 8.34808L6.52121 7.57341L1.80014 1.40931H3.83269L7.64265 6.38394L8.236 7.1586L13.1885 13.6249H11.156L7.11456 8.34837V8.34808Z"
    })]
  });
};
exports.TwitterIcon = TwitterIcon;
const YoutubeIcon = function (_ref56) {
  let {
    fill = "#666",
    $fillForeground = "#000",
    title = "Youtube Icon",
    ...props
  } = _ref56;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "153 1915 16 12",
    style: {
      enableBackground: "new 0 0 19.74 24.56"
    },
    xmlSpace: "preserve",
    fill: fill,
    ...props,
    "data-testid": "YoutubeIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: fill,
      d: "M156.2,1915h9.6c1.769,0,3.2,1.535,3.2,3.429v5.144c0,1.894-1.434,3.428-3.2,3.428h-9.6                                c-1.768,0-3.2-1.535-3.2-3.428v-5.144C153,1916.535,154.433,1915,156.2,1915z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: $fillForeground,
      d: "M159,1917v8l6-4L159,1917z"
    })]
  });
};
exports.YoutubeIcon = YoutubeIcon;
const InstagramIcon = function (_ref57) {
  let {
    fill = "#666",
    title = "Instagram Icon",
    ...props
  } = _ref57;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.74 24.56",
    style: {
      enableBackground: "new 0 0 19.74 24.56"
    },
    xmlSpace: "preserve",
    fill: fill,
    ...props,
    "data-testid": "InstagramIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: fill,
      d: "M10,1.8c2.7,0,3,0,4,0.1c1,0,1.5,0.2,1.9,0.3C16.4,2.4,16.7,2.6,17,3c0.3,0.3,0.6,0.7,0.7,1.1                                C17.9,4.5,18.1,5,18.1,6c0,1.1,0.1,1.4,0.1,4s0,3-0.1,4c0,1-0.2,1.5-0.3,1.9c-0.2,0.5-0.4,0.8-0.7,1.1c-0.3,0.3-0.7,0.6-1.1,0.7                                c-0.4,0.1-0.9,0.3-1.9,0.3c-1.1,0-1.4,0.1-4,0.1s-3,0-4-0.1c-1,0-1.5-0.2-1.9-0.3C3.6,17.6,3.3,17.4,3,17c-0.3-0.3-0.6-0.7-0.7-1.1                                C2.1,15.5,1.9,15,1.9,14c0-1.1-0.1-1.4-0.1-4s0-3,0.1-4c0-1,0.2-1.5,0.3-1.9C2.4,3.6,2.6,3.3,3,3c0.3-0.3,0.7-0.6,1.1-0.7                                C4.5,2.1,5,1.9,6,1.9C7,1.8,7.3,1.8,10,1.8 M10,0C7.3,0,6.9,0,5.9,0.1c-1.1,0-1.8,0.2-2.4,0.5C2.8,0.8,2.2,1.1,1.7,1.7                                C1.1,2.2,0.8,2.8,0.5,3.4C0.3,4.1,0.1,4.8,0.1,5.9C0,6.9,0,7.3,0,10c0,2.7,0,3.1,0.1,4.1c0,1.1,0.2,1.8,0.5,2.4                                c0.3,0.7,0.6,1.2,1.2,1.8c0.6,0.6,1.1,0.9,1.8,1.2c0.6,0.2,1.4,0.4,2.4,0.5C6.9,20,7.3,20,10,20s3.1,0,4.1-0.1                                c1.1,0,1.8-0.2,2.4-0.5c0.7-0.3,1.2-0.6,1.8-1.2c0.6-0.6,0.9-1.1,1.2-1.8c0.2-0.6,0.4-1.4,0.5-2.4c0-1.1,0.1-1.4,0.1-4.1                                s0-3.1-0.1-4.1c0-1.1-0.2-1.8-0.5-2.4c-0.3-0.7-0.6-1.2-1.2-1.8c-0.6-0.6-1.1-0.9-1.8-1.2c-0.6-0.2-1.4-0.4-2.4-0.5                                C13.1,0,12.7,0,10,0L10,0z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: fill,
      d: "M10,4.9c-2.8,0-5.1,2.3-5.1,5.1s2.3,5.1,5.1,5.1s5.1-2.3,5.1-5.1S12.8,4.9,10,4.9z M10,13.3                                c-1.8,0-3.3-1.5-3.3-3.3S8.2,6.7,10,6.7s3.3,1.5,3.3,3.3S11.8,13.3,10,13.3z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      fill: fill,
      cx: "15.3",
      cy: "4.7",
      r: "1.2"
    })]
  });
};
exports.InstagramIcon = InstagramIcon;
const PinterestIcon = function (_ref58) {
  let {
    fill = "#666",
    title = "Pinterest Icon",
    ...props
  } = _ref58;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.74 24.56",
    style: {
      enableBackground: "new 0 0 19.74 24.56"
    },
    xmlSpace: "preserve",
    fill: fill,
    ...props,
    "data-testid": "PinterestIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: fill,
      d: "M10,0C4.6,0,0.2,4.4,0.2,9.8c0,5.4,4.4,9.8,9.8,9.8c5.4,0,9.8-4.4,9.8-9.8C19.8,4.4,15.4,0,10,0z M10,18.9                            c-0.9,0-1.8-0.1-2.7-0.4c0.4-0.6,0.9-1.6,1.1-2.4C8.5,15.7,9,14,9,14c0.3,0.6,1.2,1,2.1,1c2.7,0,4.7-2.5,4.7-5.7                            c0-3-2.5-5.3-5.6-5.3c-3.9,0-6,2.6-6,5.5c0,1.3,0.7,3,1.8,3.5c0.2,0.1,0.3,0,0.3-0.1c0-0.1,0.2-0.7,0.3-1c0-0.1,0-0.2-0.1-0.3                            c-0.4-0.5-0.7-1.3-0.7-2.1c0-2,1.5-3.9,4.1-3.9c2.2,0,3.8,1.5,3.8,3.7c0,2.5-1.2,4.2-2.9,4.2c-0.9,0-1.6-0.7-1.3-1.6                            c0.3-1.1,0.8-2.2,0.8-3c0-0.7-0.4-1.3-1.2-1.3c-0.9,0-1.6,0.9-1.6,2.2c0,0.8,0.3,1.3,0.3,1.3S6.9,15,6.7,15.7                            c-0.2,0.8-0.1,1.9,0,2.6C3.3,17,0.9,13.7,0.9,9.8c0-5,4.1-9.1,9.1-9.1c5,0,9.1,4.1,9.1,9.1C19.1,14.9,15,18.9,10,18.9z"
    })]
  });
};
exports.PinterestIcon = PinterestIcon;
const WhatsAppIcon = function (_ref59) {
  let {
    fill = "#666",
    title = "WhatsApp Icon",
    ...props
  } = _ref59;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 195 195",
    style: {
      enableBackground: "new 0 0 195 195"
    },
    xmlSpace: "preserve",
    fill: fill,
    ...props,
    "data-testid": "WhatsAppIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: fill,
      d: "M0 194.497C5.281 177.447 11.402 161.237 16.998 144.503C-20.097 79.6251 25.81 6.58811 87.989 0.521114C146.696 -5.20789 194.83 36.9601 194.976 94.5091C195.129 155.232 136.236 206.222 69.991 185.497C64.994 183.934 58.811 178.84 52.993 178.498C44.862 178.019 34.206 183.857 25.996 186.497C16.997 189.392 9.172 192.293 0 194.497ZM54.993 160.501C108.488 192.967 172.544 156.552 177.978 103.508C182.896 55.4891 144.554 12.7631 92.988 16.5191C34.118 20.8061 -1.244 91.0781 34.995 142.503C31.787 151.294 28.785 160.291 25.996 169.5C35.818 166.656 44.872 163.045 54.993 160.501Z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: fill,
      d: "M75.9907 49.5152C81.6177 61.2852 90.3217 78.6942 75.9907 86.5112C83.2687 101.897 95.3017 112.528 110.986 119.507C116.202 116.057 119.627 110.816 123.985 106.509C133.089 110.07 141.599 114.224 148.981 119.507C149.74 136.708 135.245 143.069 122.985 142.504C97.1197 141.314 61.5707 108.637 52.9937 84.5112C47.9037 70.1962 53.7577 42.8162 75.9907 49.5152Z"
    })]
  });
};
exports.WhatsAppIcon = WhatsAppIcon;
const TikTokIcon = function (_ref60) {
  let {
    fill = "#666",
    title = "TikTok Icon",
    ...props
  } = _ref60;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2001 2150",
    style: {
      enableBackground: "new 0 0 2001 2150"
    },
    xmlSpace: "preserve",
    fill: fill,
    ...props,
    "data-testid": "TikTokIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: fill,
      d: "M1380.5 0C1380.5 204.5 1519 537.5 2001 505.5L2000 879C1672.5 893.5 1496 804.5 1381.5 719V1468.5C1381.5 1858 1052 2149.5 689.999 2149.5C349 2149.5 0 1882 0 1468.5C0 1017.5 370.5 771.5 689.999 771.5V1166.5C483 1173.5 394.498 1341.5 394.498 1468.5C394.498 1514.5 433.499 1753 689.999 1753C895.199 1753 984.998 1561 984.998 1468.5V0H1380.5Z"
    })]
  });
};
exports.TikTokIcon = TikTokIcon;
const SaveAsPDF = function (_ref61) {
  let {
    fill = "#666",
    title = "SaveAsPDF Icon",
    ...props
  } = _ref61;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "23",
    viewBox: "0 0 18 23",
    fill: fill,
    ...props,
    "data-testid": "SaveAsPDF",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      stroke: "#58595B",
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m7.343 16.499 1.629 1.89h.046l1.63-1.89M8.994 18.39v-6.082M9.049 8.334c0 .47-.392.853-.878.853H1l8.048-7.813v6.96z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M16.11 1.375H9.05L1 9.187v12.278c0 .469.392.848.875.848h14.24c.483 0 .874-.38.874-.848V2.227a.866.866 0 0 0-.879-.852z"
      })]
    })]
  });
};
exports.SaveAsPDF = SaveAsPDF;
const DownloadIcon = function (_ref62) {
  let {
    fill = "#888",
    title = "Download Icon",
    ...props
  } = _ref62;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 38.11",
    xmlSpace: "preserve",
    fill: fill,
    ...props,
    "data-testid": "DownloadIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M50,19.53v17.8c0,0.43-0.35,0.78-0.78,0.78H0.78C0.35,38.11,0,37.76,0,37.33v-17.8c0-0.43,0.35-0.78,0.78-0.78 s0.78,0.35,0.78,0.78v17.02h46.88V19.53c0-0.43,0.35-0.78,0.78-0.78S50,19.1,50,19.53z M24.45,24.54c0.07,0.07,0.16,0.13,0.26,0.17 c0.1,0.04,0.2,0.06,0.3,0.06s0.2-0.02,0.3-0.06c0.1-0.04,0.18-0.1,0.26-0.17l7.71-7.71c0.3-0.3,0.3-0.8,0-1.1 c-0.3-0.3-0.8-0.3-1.1,0l-6.38,6.38V0.78C25.78,0.35,25.43,0,25,0s-0.78,0.35-0.78,0.78v21.33l-6.38-6.38c-0.3-0.3-0.8-0.3-1.1,0 c-0.3,0.3-0.3,0.8,0,1.1L24.45,24.54z"
    })]
  });
};
exports.DownloadIcon = DownloadIcon;
const FilterSelector = function (_ref63) {
  let {
    fill = "none",
    title = "Filter Selector",
    ...props
  } = _ref63;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    xmlSpace: "preserve",
    fill: "none",
    ...props,
    "data-testid": "FilterSelector",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: "3",
      cy: "4",
      r: "2",
      stroke: "black",
      "stroke-width": "2"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: "13",
      cy: "12",
      r: "2",
      stroke: "black",
      "stroke-width": "2"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M12 4H5",
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M11 12H4",
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round"
    })]
  });
};
exports.FilterSelector = FilterSelector;
const TopDown = function (_ref64) {
  let {
    fill = "#888",
    title = "Convertible Top Down Icon",
    ...props
  } = _ref64;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151.69 32.57",
    fill: fill,
    ...props,
    "data-testid": "TopDown",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M482.45,400.75l-2.83-1c.11-.31.19-.57.26-.8a1.71,1.71,0,0,1-.47-.34,1.5,1.5,0,0,1-.36-1.28c0-.15.07-.38.13-.68a38.79,38.79,0,0,0,1-7.6,6.83,6.83,0,0,0-1.64-3.34,7.48,7.48,0,0,1-.83-1.25,4.65,4.65,0,0,1-.48-3.48l-.8,0c-1.69.07-4.26.17-5.45.09-15.94-1.35-20-1.69-21.17-1.85v0a7.38,7.38,0,0,1-1.52-.34l-.44-.12-.39-.11-1.56-.4a31.55,31.55,0,0,0-4.25-.68,1.79,1.79,0,0,1-1.18-.55l-.12-.14h0c-1.58,0-1.91.33-1.92.34,0,.74-.37,1.77-2.29,2.18a3.93,3.93,0,0,1-.6.06h-.11l-.41.24A9.65,9.65,0,0,1,432.3,381a12.42,12.42,0,0,1-2.39.36,1.5,1.5,0,0,1-1.47-.94l-.1-.23a5.33,5.33,0,0,0-.52-1c-.32-.54-.83-1.35-1.33-2.14s-.91-1.44-1.2-1.91l-.17-.29a1.5,1.5,0,0,1-.84.55c.07.5.08,2.19.27,3.33a1.5,1.5,0,0,1-.56,1.44,2.82,2.82,0,0,1-.49.3,1.5,1.5,0,0,1-1.39,1.18c-6,.3-20.06,1-23.1,1.26a1.48,1.48,0,0,1-1.35-.63,1.5,1.5,0,0,1-.14-1.49l.12-.23c.49-.94.4-1.19.38-1.23s-.51-.41-1.81-.49a1.5,1.5,0,0,1-1.37-1.17,1.48,1.48,0,0,1,.74-1.64l.26-.15c.68-.38,2-1.13,3.68-2-4.86,2-11.37,4.86-16.5,7.42a1.87,1.87,0,0,1-.4.13l-.73.14a1.8,1.8,0,0,1-.39.08h0l-6.89.35c-1.49.11-14.93,1.11-25.27,3.89-8.92,2.39-12.72,6.43-14,7.75a6.21,6.21,0,0,1-.55.54,4.88,4.88,0,0,0-.23,3.13c.08.53.23,1.12.38,1.74l.2.81-2.92.68-.19-.77c-.16-.65-.33-1.33-.43-2-.44-2.63.08-5,1.32-6l.24-.25c1.39-1.48,5.63-6,15.37-8.6,10.61-2.85,24.32-3.87,25.85-4l6.86-.35a6.21,6.21,0,0,1,.62-.14c9.48-4.71,23.37-10.23,23.51-10.29l.33-.09a2.43,2.43,0,0,1,1.56.42l.61.31a1.47,1.47,0,0,1,.89,1.1,3.47,3.47,0,0,1,0,1.66l0,.2a1.73,1.73,0,0,1-.11.32,2.54,2.54,0,0,1-1.54,1.36,1.71,1.71,0,0,0-.36.17,1,1,0,0,1-.21.11c-2.2,1-4.63,2.24-6.5,3.25a3.17,3.17,0,0,1,.66.81,3.29,3.29,0,0,1,.39,1.92c4.83-.31,14.6-.8,20-1.07a2.25,2.25,0,0,1,.48-.53c-.1-1.09-.11-2.23-.11-2.76a3,3,0,0,1,1.56-2.66,2.59,2.59,0,0,1,2.32-1.18h.15c1.33.09,1.92,1.08,2.49,2,.27.45.7,1.14,1.15,1.84s1.05,1.66,1.38,2.22c.14.23.25.41.33.56a6.29,6.29,0,0,0,.8-.16l.11,0a7.4,7.4,0,0,0,1.77-.87c.25-.15.48-.29.66-.38a2.87,2.87,0,0,1,1.23-.29h.18a2.78,2.78,0,0,1,.78-1.38c1.13-1.12,3-1.22,4.27-1.2h.27a2.07,2.07,0,0,1,1.61.51,1.25,1.25,0,0,1,.23.27,33.47,33.47,0,0,1,3.92.68l1.62.41.39.1.54.16a5,5,0,0,0,.92.22h0l21.14,1.82c1,.07,3.57,0,5.1-.09l1.09,0a2.36,2.36,0,0,1,2.54,1.17l.11.18a2.23,2.23,0,0,1,.09,2.39c-.13.54-.06.72.29,1.48.06.11.31.45.5.7a9.47,9.47,0,0,1,2.25,5V389a39.49,39.49,0,0,1-.87,7.56,2.42,2.42,0,0,1,.5.47,1.44,1.44,0,0,1,.18.25C483.3,397.94,483.21,398.59,482.45,400.75Zm-2.3-2.73Zm-44.68-18.53h0Zm7.48-3.68Z",
      transform: "translate(-331.45 -368.19)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M467,400.3a12.71,12.71,0,0,0-25.4,0l-2-.08a14.71,14.71,0,0,1,29.4,0Z",
      transform: "translate(-331.45 -368.19)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M372.25,400.3a12.71,12.71,0,0,0-25.4,0l-2-.08a14.71,14.71,0,0,1,29.4,0Z",
      transform: "translate(-331.45 -368.19)"
    })]
  });
};
exports.TopDown = TopDown;
const TopUp = function (_ref65) {
  let {
    fill = "#888",
    title = "Convertible Top Up Icon",
    ...props
  } = _ref65;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151.71 33.91",
    fill: fill,
    ...props,
    "data-testid": "TopUp",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M263.35,400.3a12.71,12.71,0,0,0-25.4,0l-2-.08a14.71,14.71,0,0,1,29.4,0Z",
      transform: "translate(-127.89 -366.84)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M168.59,400.3a12.72,12.72,0,0,0-25.41,0l-2-.08a14.71,14.71,0,0,1,29.4,0Z",
      transform: "translate(-127.89 -366.84)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M278.91,400.75l-2.83-1c.11-.31.19-.57.26-.8a1.71,1.71,0,0,1-.47-.34,1.5,1.5,0,0,1-.36-1.28c0-.15.07-.38.13-.68a38.79,38.79,0,0,0,1-7.6,6.83,6.83,0,0,0-1.64-3.34,7.09,7.09,0,0,1-.83-1.25,4.65,4.65,0,0,1-.48-3.48l-.8,0c-1.69.07-4.25.17-5.45.09l-17.25-1.48a1.5,1.5,0,0,1-.73-.26,12.09,12.09,0,0,0-1.85-1.05l-.19-.1a14.7,14.7,0,0,0-1.83-1c-.12,0-3.86-1.86-8-3.53a25.67,25.67,0,0,0-2.55-1,68.5,68.5,0,0,0-13.06-2.44c-1.21-.14-2.49-.21-3.72-.28l-1.84-.12c-5.54-.39-12.13.6-13.73,1.24l-.15.06c-.93.31-14.61,5.94-23,10.13a1.87,1.87,0,0,1-.4.13l-.73.14a1.59,1.59,0,0,1-.39.08h0l-6.88.35c-1.5.11-14.94,1.11-25.28,3.89a36.83,36.83,0,0,0-6.21,2.24,26.89,26.89,0,0,0-4.22,2.43,20.17,20.17,0,0,0-4,3.59,4.47,4.47,0,0,0-.28,3.16c.09.53.24,1.11.39,1.73l.2.82-2.92.68-.19-.78c-.16-.65-.33-1.32-.43-2-.29-1.67-.36-4,.91-5.55a23.49,23.49,0,0,1,4.64-4.15,32,32,0,0,1,4.67-2.69,41.38,41.38,0,0,1,6.71-2.42c10.61-2.85,24.32-3.87,25.85-4l6.87-.35c.2-.06.41-.1.61-.14,8.35-4.14,21.53-9.58,23.18-10.19h0c2.12-.85,9.2-1.86,15.07-1.45l1.81.11c1.27.07,2.58.15,3.88.3a70.31,70.31,0,0,1,13.64,2.57,28.68,28.68,0,0,1,2.81,1.07c4.19,1.68,8,3.53,8.06,3.55a18.36,18.36,0,0,1,2.09,1.08,15.79,15.79,0,0,1,1.92,1.06l16.84,1.45c1,.07,3.57,0,5.1-.09l1.09,0a2.35,2.35,0,0,1,2.54,1.18l.11.17a2.23,2.23,0,0,1,.09,2.39c-.13.54-.06.72.29,1.48a6.7,6.7,0,0,0,.5.7,9.47,9.47,0,0,1,2.25,5V389a39.49,39.49,0,0,1-.87,7.56,2.72,2.72,0,0,1,.5.47,1.44,1.44,0,0,1,.18.25C279.74,397.9,279.71,398.46,278.91,400.75Z",
      transform: "translate(-127.89 -366.84)"
    })]
  });
};
exports.TopUp = TopUp;
const HeartIcon = function (_ref66) {
  let {
    fill = "none",
    title = "Heart Icon",
    ...props
  } = _ref66;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 20",
    xmlSpace: "preserve",
    fill: fill,
    ...props,
    "data-testid": "HeartIcon",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M2.68742 10.9261L9.9214 18.2225C10.4775 18.7813 11.3901 18.7896 11.9515 18.2352C12.1362 18.0529 19.2175 10.9261 19.2175 10.9261C20.1601 9.8631 21 8.80751 21 6.87585C21 3.6335 18.7536 1 15.4572 1C13.5355 1 12.1483 2.00397 11 3.49904L11.0046 3.5C9.8889 2.00493 8.42249 1 6.50074 1C3.20435 1 1 3.6335 1 6.87585C1 8.69953 1.77635 9.87116 2.68742 10.9261Z",
      stroke: "black",
      strokeWidth: "1.2",
      strokeLinejoin: "round"
    })
  });
};
exports.HeartIcon = HeartIcon;
const ToyotaLogoIcon = function (_ref67) {
  let {
    fill = "none",
    title = "Toyota Logo Icon",
    ...props
  } = _ref67;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 16",
    width: 17,
    height: 16,
    fill: fill,
    ...props,
    "data-testid": "ToyotaLogoIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      width: "16.4671",
      height: "16",
      fill: "#EB0A1E"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.17925 4.4629C5.07251 4.46639 2.69727 6.02239 2.69727 8.09628C2.69727 10.1725 5.01562 11.7246 8.18974 11.7246C11.3639 11.7246 13.6563 10.1019 13.6563 8.09628C13.6563 6.09281 11.2809 4.46647 8.17925 4.4629ZM8.17925 4.4629L8.169 4.46289H8.18974L8.17925 4.4629ZM11.587 6.02055C11.7063 6.46906 11.1669 7.02843 9.43982 7.20984C9.32571 6.07095 8.97822 5.10843 8.40252 4.90181C9.13585 4.91829 9.86204 5.0458 10.5549 5.27976C11.1565 5.49646 11.53 5.7837 11.5922 6.02055H11.587ZM8.1742 10.1225C8.58912 10.1225 9.03516 9.52283 9.03516 8.07653C8.76027 8.1118 8.47502 8.1118 8.1742 8.1118C7.87339 8.1118 7.58813 8.10172 7.30806 8.07653C7.30806 9.52283 7.75928 10.1225 8.1742 10.1225ZM8.17418 7.27016H7.35991C7.49476 6.32275 7.84225 5.75835 8.17418 5.75835C8.50612 5.75835 8.84843 6.30764 8.98327 7.27016H8.17418ZM5.78854 5.27976C5.18172 5.51661 4.80829 5.77866 4.75124 6.02055H4.7668C4.6527 6.46906 5.18691 7.02843 6.914 7.20984C7.02292 6.07095 7.37041 5.10843 7.9513 4.90181C7.2146 4.91839 6.48501 5.04589 5.78854 5.27976ZM3.50632 7.96493C3.50086 7.38879 3.70679 6.82959 4.08721 6.38761C4.13388 7.19895 5.26454 7.80367 6.87234 8.01532V8.0758C6.87234 10.0311 7.39099 11.0692 7.9615 11.2859C5.50311 11.2002 3.50632 9.72871 3.50632 7.96493ZM9.50724 8.0758C9.50724 9.95044 8.98859 11.0641 8.40252 11.2859H8.40771C10.8713 11.2052 12.8733 9.72871 12.8733 7.96493C12.8787 7.38879 12.6728 6.82959 12.2924 6.38761C12.2457 7.19895 11.1202 7.80367 9.50724 8.01532V8.0758Z",
      fill: "white"
    })]
  });
};
exports.ToyotaLogoIcon = ToyotaLogoIcon;
const ToyotaInfoIcon = function (_ref68) {
  let {
    fill = "none",
    title = "Info Icon",
    ...props
  } = _ref68;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    width: 12,
    height: 12,
    fill: fill,
    ...props,
    "data-testid": "ToyotaInfoIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      clipPath: "url(#clip0_514_114123)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        width: "11",
        height: "11",
        transform: "translate(0.466797 0.5)",
        fill: "white"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "5.9668",
        cy: "6",
        r: "4.8125",
        fill: "black",
        stroke: "black",
        strokeWidth: "1.375"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M5.9668 5.3125L5.9668 8.75",
        stroke: "white",
        strokeWidth: "1.375"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "5.9668",
        cy: "3.9375",
        r: "0.6875",
        fill: "white"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "clip0_514_114123",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          width: "11",
          height: "11",
          fill: "white",
          transform: "translate(0.466797 0.5)"
        })
      })
    })]
  });
};
exports.ToyotaInfoIcon = ToyotaInfoIcon;
const CopyIcon = function (_ref69) {
  let {
    fill = "none",
    title = "Copy Icon",
    ...props
  } = _ref69;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 15",
    width: 14,
    height: 15,
    fill: fill,
    ...props,
    "data-testid": "CopyIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      clipPath: "url(#clip0_514_114133)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        x: "2.1875",
        y: "2.18945",
        width: "7",
        height: "9.625",
        rx: "0.4375",
        stroke: "black",
        strokeWidth: "0.875"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M11.375 3.50195V13.127C11.375 13.6102 10.9832 14.002 10.5 14.002H3.5",
        stroke: "black",
        strokeWidth: "0.875",
        strokeLinecap: "round"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "clip0_514_114133",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          width: "14",
          height: "14",
          fill: "white",
          transform: "translate(0 0.876953)"
        })
      })
    })]
  });
};
exports.CopyIcon = CopyIcon;
function Check(_ref70) {
  let {
    fill = "white",
    ...rest
  } = _ref70;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    "aria-label": "Check mark icon",
    width: "16",
    height: "12",
    viewBox: "0 0 16 12",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    ...rest,
    "data-testid": "Check",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: "Check mark"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "Vector",
      d: "M15.8784 1.62215L14.7433 0.500002L5.88592 9.27047L1.25627 4.74264L0.121094 5.86479L5.88592 11.5L15.8784 1.62215Z",
      fill: fill
    })]
  });
}
const CircleSlashIcon = function (_ref71) {
  let {
    fill = "black",
    ...props
  } = _ref71;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    "data-testid": "CircleSlashIcon",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      opacity: "0.2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        x: "1.16675",
        y: "0.5",
        width: "15",
        height: "15",
        rx: "7.5",
        stroke: fill
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M4.07057 13.3033L3.36346 12.5962L13.263 2.6967L13.9701 3.40381L4.07057 13.3033Z",
        fill: fill
      })]
    })
  });
};
exports.CircleSlashIcon = CircleSlashIcon;
const NoticeIcon = function (_ref72) {
  let {
    fill = "white",
    ...props
  } = _ref72;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    fill: "none",
    height: "36",
    width: "36",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    "data-testid": "NoticeIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      clipPath: "url(#a)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M18 2c8.822 0 16 7.178 16 16s-7.178 16-16 16S2 26.822 2 18 9.178 2 18 2Zm0-2C8.059 0 0 8.059 0 18s8.059 18 18 18 18-8.059 18-18S27.941 0 18 0Z",
        fill: fill
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m18 27.33-.036-13.084",
        stroke: fill,
        strokeMiterlimit: "10",
        strokeWidth: "2"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M18 12.256a1.793 1.793 0 1 0 0-3.586 1.793 1.793 0 0 0 0 3.586Z",
        fill: fill
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "a",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fill: fill,
          d: "M0 0h36v36H0z"
        })
      })
    })]
  });
};
exports.NoticeIcon = NoticeIcon;
const ConfirmedIcon = function (_ref73) {
  let {
    fill = "white",
    ...props
  } = _ref73;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    fill: "none",
    height: "36",
    width: "36",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    "data-testid": "ConfirmedIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      clipPath: "url(#a)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M18 2c8.822 0 16 7.178 16 16s-7.178 16-16 16S2 26.822 2 18 9.178 2 18 2Zm0-2C8.059 0 0 8.059 0 18s8.059 18 18 18 18-8.059 18-18S27.941 0 18 0Z",
        fill: fill
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m9.07715 17.4811 6.29395 6.295 11.552-11.552",
        stroke: fill,
        strokeMiterlimit: "10",
        strokeWidth: "2"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "a",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fill: fill,
          d: "M0 0h36v36H0z"
        })
      })
    })]
  });
};
exports.ConfirmedIcon = ConfirmedIcon;
const UnavailableIcon = function (_ref74) {
  let {
    fill = "white",
    ...props
  } = _ref74;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.SVG, {
    fill: "none",
    height: "36",
    width: "36",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    "data-testid": "UnavailableIcon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      "clip-path": "url(#a)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M18 2c8.822 0 16 7.178 16 16s-7.178 16-16 16S2 26.822 2 18 9.178 2 18 2Zm0-2C8.059 0 0 8.059 0 18s8.059 18 18 18 18-8.059 18-18S27.941 0 18 0Z",
        fill: fill
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M5.27197 5.27197 30.728 30.728",
        stroke: fill,
        strokeMiterlimit: "10",
        strokeWidth: "2"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "a",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fill: fill,
          d: "M0 0h36v36H0z"
        })
      })
    })]
  });
};
exports.UnavailableIcon = UnavailableIcon;